// The cookpit "Start" cue — the lane-A0 alarm at the very start of a phase
// (preCook / prepCook / liveCook), action "Start.". It carries no hands-on
// work, so CookChow omits it from the cook surfaces (live cook, Preview).
// This is a display-layer omission: the signed file and the server projection
// are unchanged. Only the *earliest* A0 alarm per phase is the Start cue —
// the other A0 alarms ("Ten minutes remaining", "Time up") are kept.

import type { PhaseId, ScheduleEntry } from '@cookchow/shared';

/** The id of each phase's Start cue (earliest lane-A0 alarm), as a set. */
export function phaseStartCueIds(schedule: readonly ScheduleEntry[]): Set<string> {
  const earliest = new Map<PhaseId, ScheduleEntry>();
  for (const t of schedule) {
    if (t.kind !== 'alarm' || t.lane !== 'A0') continue;
    const cur = earliest.get(t.phase);
    if (!cur || Date.parse(t.startAt) < Date.parse(cur.startAt)) earliest.set(t.phase, t);
  }
  return new Set([...earliest.values()].map((t) => t.id));
}

/** The schedule with every phase's Start cue removed. */
export function withoutPhaseStartCues(schedule: readonly ScheduleEntry[]): ScheduleEntry[] {
  const ids = phaseStartCueIds(schedule);
  return schedule.filter((t) => !ids.has(t.id));
}
